// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"441":"81271a46","945":"90664f53"}[chunkId] + ".chunk.js";
};